(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spicy-brand-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(root) {
    if (!root || root.__mqBooted) return;
    root.__mqBooted = true;

    var track = root.querySelector('[data-mq-track]');
    var copy = root.querySelector('[data-mq-copy]');
    if (!track || !copy) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = parseFloat(root.getAttribute('data-speed'));
    if (!isFinite(speed) || speed <= 0) speed = 55;

    function setPace() {
      var w = copy.scrollWidth;              // width of ONE copy
      if (!w) return;
      root.style.setProperty('--mq-dur', (w / speed).toFixed(2) + 's');
    }

    setPace();

    /* Webfonts land after first paint and change every measurement here, so
       the pace is recalculated once they are in rather than being locked to
       fallback-font widths. */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(setPace).catch(function () {});
    }

    var t = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(t);
      t = window.setTimeout(setPace, 200);
    }, { passive: true });
  }

  function boots(scope) {
    var roots = (scope || document).querySelectorAll('[data-mq]');
    Array.prototype.forEach.call(roots, boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boots(); }, { once: true });
  } else {
    boots();
  }

  document.addEventListener('shopify:section:load', function (e) { boots(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spicy-home-immersive-footer"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   SPICY HOME — IMMERSIVE BRAND FOOTER
   Self-contained. No globals, no shared state, no dependency on the theme's
   scroll engine, GSAP or Lenis. Reads geometry once per animation frame and
   only while the component is near the viewport; writes nothing but two
   custom properties, which drive compositor-only transforms in CSS.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-spicy-immersive-footer]';

  function setup(root) {
    if (root.spicyImmersiveFooterReady) return;
    root.spicyImmersiveFooterReady = true;

    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Reduced motion, or no support for the APIs this needs: leave the
       default (finished) rendering exactly as the CSS already has it. */
    if (reduceQuery.matches ||
        typeof window.IntersectionObserver !== 'function' ||
        typeof window.requestAnimationFrame !== 'function') {
      return;
    }

    var near = false;
    var queued = false;

    function measure() {
      queued = false;

      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (!vh) return;

      /* progress: 0 when the top edge sits a full viewport below the fold,
         1 once it has risen to a third of the way up the screen */
      var from = vh;
      var to = vh * 0.30;
      var p = (from - rect.top) / (from - to);
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      p = p * p * (3 - 2 * p);              /* smoothstep: no hard start or stop */

      /* drift keeps moving after the reveal has finished, which is what gives
         the layers their sense of depth rather than a one-shot animation */
      var centre = rect.top + rect.height / 2;
      var drift = ((vh / 2) - centre) / vh;
      drift = drift < -1 ? -1 : (drift > 1 ? 1 : drift);

      root.style.setProperty('--spicy-footer-p', p.toFixed(4));
      root.style.setProperty('--spicy-footer-drift', drift.toFixed(4));
    }

    function request() {
      if (!near || queued) return;
      queued = true;
      window.requestAnimationFrame(measure);
    }

    var observer = new window.IntersectionObserver(function (entries) {
      near = entries[0].isIntersecting;
      if (near) request();
    }, { rootMargin: '25% 0px 25% 0px' });

    observer.observe(root);

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });

    /* Opt in to the animated state only now that it is actually driven. */
    root.setAttribute('data-spicy-footer-state', 'live');
    measure();
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  } else {
    boot();
  }

  /* the theme editor rebuilds a section on every edit */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spicy-sofas"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var MOBILE = 767;

  function init(root) {
    if (root.__shSofasBooted) return;
    root.__shSofasBooted = true;

    var track = root.querySelector('[data-sh-sofas-track]');
    var stage = root.querySelector('[data-sh-sofas-stage]');
    var rail = root.querySelector('[data-sh-sofas-rail]');
    var bar = root.querySelector('[data-sh-sofas-bar]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sh-sofas-panel]'));
    if (!track || !stage || !rail || !panels.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var st = null;
    var distance = 0;

    function teardown() {
      if (st) { st.kill(); st = null; }
      track.style.height = '';
      rail.style.setProperty('--sh-sofas-x', '0px');
      if (bar) bar.style.transform = 'scaleX(0)';
    }

    function apply(p) {
      rail.style.setProperty('--sh-sofas-x', (-distance * p).toFixed(2) + 'px');
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }

    function build() {
      teardown();

      if (window.innerWidth <= MOBILE || reduced.matches) return;
      if (!window.gsap || !window.ScrollTrigger) return;

      distance = rail.scrollWidth - stage.clientWidth;
      if (distance <= 0) return;          
      track.style.height = (stage.offsetHeight + (distance * 0.72)) + 'px';

      window.gsap.registerPlugin(window.ScrollTrigger);
      st = window.ScrollTrigger.create({
        trigger: track,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0.6,
        invalidateOnRefresh: true,
        onUpdate: function (self) { apply(self.progress); }
      });
      apply(0);
    }

        rail.addEventListener('focusin', function (e) {
      if (!st || !distance) return;
      var panel = e.target.closest ? e.target.closest('[data-sh-sofas-panel]') : null;
      if (!panel) return;
      var i = panels.indexOf(panel);
      if (i < 0) return;
      var p = panels.length > 1 ? i / (panels.length - 1) : 0;
      var y = st.start + (st.end - st.start) * p;
      if (window.SpicyScroll) window.SpicyScroll.scrollTo(y, { offset: 0 });
      else window.scrollTo(0, y);
    });

    var t = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(t);
      t = window.setTimeout(build, 180);
    }, { passive: true });

    if (reduced.addEventListener) reduced.addEventListener('change', build);

    if (document.readyState === 'complete') build();
    else window.addEventListener('load', build, { once: true });
    build();
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-sh-sofas]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spicy-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(root) {
    if (!root || root.__tqBooted) return;
    root.__tqBooted = true;

    var viewport = root.querySelector('[data-tq-viewport]');
    var rail = root.querySelector('[data-tq-rail]');
    if (!viewport || !rail) return;

    /* Touch keeps its own momentum, and a visitor who asked for less motion
       gets a plain scroller. Both are better than a driven rail. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    if (!window.gsap || !window.ScrollTrigger) return;

    var travel = 0;

    function measure() {
      // How far the rail has to move for its last card to reach the right edge.
      travel = Math.max(0, rail.scrollWidth - viewport.clientWidth);
      if (travel <= 0) root.style.setProperty('--tq-x', '0px');
    }

    measure();
    if (travel <= 0) return;   // everything already fits; leave it alone

    root.classList.add('is-driven');

    /* end is 'bottom bottom', NOT 'bottom top'.

       'bottom top' only completes once the section has left through the top
       of the viewport, which requires a full viewport of scrolling to exist
       below it. Measured on this homepage that scroll does not exist — the
       page ends shortly after — so the rail reached about 44% of its travel
       and simply stopped, stranding the last two reviews off-screen forever.

       'bottom bottom' completes the moment the section is fully in view,
       which is reachable for any section that can be scrolled to at all. */
    window.ScrollTrigger.create({
      trigger: root,
      start: 'top bottom',
      end: 'bottom bottom',
      invalidateOnRefresh: true,
      onRefresh: measure,
      onUpdate: function (self) {
        if (travel <= 0) return;
        /* Hold still for the first stretch so the rail is not already moving
           before the visitor can see it, then use the rest of the pass. */
        var p = (self.progress - 0.12) / 0.78;
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        root.style.setProperty('--tq-x', (-p * travel).toFixed(1) + 'px');
      }
    });
  }

  function boots(scope) {
    var roots = (scope || document).querySelectorAll('[data-tq]');
    Array.prototype.forEach.call(roots, boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boots(); }, { once: true });
  } else {
    boots();
  }

  document.addEventListener('shopify:section:load', function (e) { boots(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
